import api from './api';

function mapMember(m) {
  return {
    id: m.id,
    name: m.name,
    email: m.email,
    cpf: m.cpf,
    phone: m.phone,
    birthDate: m.birth_date,
    feituraDate: m.feitura_date,
    idadeDeSanto: m.idade_de_santo,
    orixa: m.orixa,
    junto: m.junto,
    obrigacoesPagas: m.obrigacoes_pagas,
    status: m.status,
    photoUrl: m.photo_url,
    createdAt: m.created_at,
  };
}

/**
 * Lista associados com filtros e paginação.
 */
export const getMembers = async (params = {}) => {
  try {
    const response = await api.get('/members', { params });
    const { data, meta } = response.data;

    return {
      data: data.map(mapMember),
      meta,
      total: meta?.total || data.length,
      page: meta?.current_page || 1,
      pageSize: meta?.per_page || 15,
      lastPage: meta?.last_page || 1,
    };
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao buscar associados.');
  }
};

/**
 * Atualiza o status do associado (aprovar, rejeitar, inativar).
 */
export const updateMemberStatus = async (id, status) => {
  try {
    const response = await api.patch(`/members/${id}/status`, { status });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Erro ao atualizar status do associado.');
  }
};
